// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--Bn3ZF","icon":"a10a3f92e9--icon--bYnJn","text":"a10a3f92e9--text--PMeBD"};